export default "{{$ctrl.timezone_formatted}}";